import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";


const Aboutsliderimages = () => {
  const images = [
    { id: 1, image: `${API_URL}/media/images/ren1 (14).jpg`, caption: 'Image 1' },
    { id: 2, image: `${API_URL}/media/images/ren1 (12).jpeg`, caption: 'Image 2' },
    { id: 8, image: `${API_URL}/media/images/ren1 (3).jpg`, caption: 'Image 8' },
    { id: 3, image: `${API_URL}/media/images/ren1 (3).jpeg`, caption: 'Image 3' },
    { id: 4, image: `${API_URL}/media/images/ren1 (14).jpeg`, caption: 'Image 4' },
    { id: 5, image: `${API_URL}/media/images/ren1 (12).jpeg`, caption: 'Image 5' },
    { id: 6, image: `${API_URL}/media/images/ren1 (6).jpeg`, caption: 'Image 6' },
    { id: 7, image: `${API_URL}/media/images/ren1 (49).jpg`, caption: 'Image 7' },
    { id: 9, image: `${API_URL}/media/images/ren1 (36).jpg`, caption: 'Image 9' },
    { id: 10, image: `${API_URL}/media/images/ren1 (12).jpg`, caption: 'Image 10' },
    { id: 11, image: `${API_URL}/media/images/ren1 (51).jpg`, caption: 'Image 11' },
  ];

  return (
    <Swiper
      id="aboutpageslider"
      className="aboutpageslider"
      modules={[Pagination, Autoplay]}
      pagination={{ clickable: true }}
      loop={true}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      spaceBetween={0}
      breakpoints={{
        320: { slidesPerView: 1 },
        480: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 4 },
      }}
    >
      {images.map((img, index) => (
        <SwiperSlide key={img.id || index}>
          <div
            style={{
              border: '1px solid #00000010',
              height: '350px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              background: '#fff',
            }}
          >
            <img
              src={img.image}
              alt={img.caption}
              style={{
                maxWidth: '100%',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Aboutsliderimages;
